module.exports = __webpack_public_path__ + "static/img/img@2x.eb7d4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/img@2x.png
// module id = PYdZ
// module chunks = 70